var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft16 = function SvgArrowLeft16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m5.353 6.94 5.293-5.294.707.708-5.292 5.292a.5.5 0 0 0 0 .708l5.292 5.293-.707.707L5.353 9.06a1.5 1.5 0 0 1 0-2.122",
    clipRule: "evenodd"
  })));
};
export default SvgArrowLeft16;